import { PendingQuestions, Case } from "../apis/API";
import { getCurrentTimeInSeconds } from "./UtilityFunctions";

/**
 * Validates if questions are currently due (within the scheduled time window)
 * - Checks that pendingQuestions exists and has required fields (promptId, startTime, answersValidUntil)
 * - Verifies that current time falls within the startTime and answersValidUntil window
 */
export const areQuestionsDue = (
  pendingQuestions: PendingQuestions | null | undefined,
): boolean => {
  if (
    !pendingQuestions?.promptId ||
    !pendingQuestions.startTime ||
    !pendingQuestions.answersValidUntil
  ) {
    return false;
  }
  const currentTime = getCurrentTimeInSeconds();
  return (
    currentTime >= pendingQuestions.startTime &&
    currentTime <= pendingQuestions.answersValidUntil
  );
};

/**
 * Validates if the "Answer Now" button should be shown for self-triggered questions
 * - Checks that the self-triggered questions feature flag is enabled
 * - Verifies that no questions are currently due (inverse of areQuestionsDue)
 * - Validates that the participant has a valid question assignment with a questionGroupId
 * - Ensures that the question assignment has at least one question available
 */
export const canAnswerQuestionsNow = (
  isSelfTriggeredQuestionsEnabled: boolean,
  participantCase: Case | null | undefined,
  areQuestionsDueNow: boolean,
): boolean => {
  return (
    isSelfTriggeredQuestionsEnabled &&
    !areQuestionsDueNow &&
    participantCase?.questionAssignment?.questionGroupId != null &&
    (participantCase?.questionAssignment?.agencyQuestionGroup
      ?.localizedParticipantQuestions?.length ?? 0) > 0
  );
};
